/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * One selectable row of an Appearance radio group, with an optional live example.
 */
import React from "react";
import { Label, RadioGroupItem } from "@lemonadetraining/web-ui";

type OptionRowProps = {
  id: string;
  value: string;
  label: string;
  example?: string;
  describedBy?: string;
};

const OptionRow: React.FC<OptionRowProps> = ({ id, value, label, example, describedBy }) => (
  <Label
    htmlFor={id}
    data-testid="appearance-option-row"
    className="flex min-h-[44px] cursor-pointer items-center gap-3 rounded-lg border border-border p-3 font-normal hover:bg-muted/60 has-[[data-state=checked]]:border-ring has-[:disabled]:cursor-not-allowed has-[:disabled]:hover:bg-transparent"
  >
    <RadioGroupItem id={id} value={value} aria-describedby={describedBy} />
    <span className="flex flex-1 flex-wrap items-center justify-between gap-2">
      <span className="text-foreground">{label}</span>
      {example ? <span className="text-muted-foreground tabular-nums">{example}</span> : null}
    </span>
  </Label>
);

export default OptionRow;
